import store from '@/store';
import router from '@/router';
import { CABINET } from '@/router/const';

import {
  DEAL_UPDATE,
  TRANSACTION_UPDATE,
  SELF_EMPLOYED_APPROVAL,
  TELEGRAM_SUBSCRIPTION,
  TELEGRAM_UNSUBSCRIPTION,
  TELEGRAM_TWO_FACTOR_CONFIRMATION,
  IDENTIFICATION_STATUS_CHANGE,
  TRANSACTION_BROWSING_APPROVAL
} from '@/const';

import { EVENT_BUS } from '@/eventBus';

export default {
  async updateCabinet() {
    await store.dispatch('APP_INIT_LOAD');

    store.dispatch('GET_GRAPH');
    store.dispatch('GET_TRANSACTIONS', {
      page: 1,
      reset: true,
    });
  },

  approvalSelfEmployed(status) {
    store.commit('SET_SELF_EMPLOYED_STATUS', status);
  },

  telegramBotSignedEvent(event) {
    store.commit('SET_BOT_SIGNED_EVENT', event);
  },

  // eslint-disable-next-line complexity
  mainProcess(e) {
    if (!e.data) {
      return console.error('[error in mainProcess method]');
    }

    const data = JSON.parse(e.data);

    // eslint-disable-next-line no-console
    console.log('SOCKET', data);

    switch (data.event) {
      case DEAL_UPDATE:
        EVENT_BUS.$emit(DEAL_UPDATE, data);
        break;
      case TRANSACTION_UPDATE:
        this.updateCabinet();
        break;
      case SELF_EMPLOYED_APPROVAL:
        this.approvalSelfEmployed(data.status);
        break;
      case TELEGRAM_SUBSCRIPTION:
        this.telegramBotSignedEvent(true);
        break;
      case TELEGRAM_UNSUBSCRIPTION:
        this.telegramBotSignedEvent(false);
        break;
      case TELEGRAM_TWO_FACTOR_CONFIRMATION:
        store.commit('CLEAR_ALL_STATE');
        localStorage.setItem('token', data.token);
        router.push({ name: CABINET });
        break;
      case IDENTIFICATION_STATUS_CHANGE:
        store.dispatch('identity/fetchIdentification');
        store.dispatch('GET_MERCHANT_INFO');
        EVENT_BUS.$emit(IDENTIFICATION_STATUS_CHANGE, data);
        break;
      case TRANSACTION_BROWSING_APPROVAL:
        EVENT_BUS.$emit(TRANSACTION_BROWSING_APPROVAL, data);
        break;
    }
  },
};
